

export function createSelectOptions(rules, data) {
    let options = []

    data[rules.loopField].forEach(object => {

        let option = {}

        // label
        let labelString = ''
        rules.label.forEach((label, index) => {

            if(label.includes('.')) {
                let labels = label.split('.')
                labelString = labelString.concat(`${object[labels[0]][labels[1]]}${index === rules.label.length - 1 ? '' : ' - '}`)
            } else {
                labelString = labelString.concat(`${object[label]}${index === rules.label.length - 1 ? '' : ' - '}`)
            }
            
        })
        option['label'] = labelString

        // value
        option['id'] = object[rules.value]

        option['data'] = {...object}

        // group
        option['group'] = null

        if(rules.groupBy) {
            if(rules.groupBy.includes(".")) {
                const allNestingKeys = rules.groupBy.split(".")
                let currentValue = {...object}
                allNestingKeys.forEach(nestedKey => {
                    currentValue = currentValue[nestedKey] ? currentValue[nestedKey] : ""
                })
                option['group'] = currentValue
            } else {
                option['group'] = object[rules.groupBy]
            }
            
        }

        options.push(option)
    })


    return options.sort((a, b) => {
        if(a.group < b.group) {
            return -1;
        }
        if(a.group > b.group) {
            return 1;
        }
        return 0;
    })
} 